import { render } from "./MenusTableRow.vue?vue&type=template&id=0f5f8aaa"
import script from "./MenusTableRow.vue?vue&type=script&lang=js"
export * from "./MenusTableRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__